export default function SectionHeading({ eyebrow, title, description, align = "left" }) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl ${align === "center" ? "mx-auto" : ""}`}>
      {eyebrow && (
        <span className="text-[11px] uppercase tracking-[0.32em] text-[#D4AF37] font-semibold mb-4">
          {eyebrow}
        </span>
      )}
      <h2 className="font-display text-3xl md:text-4xl lg:text-[44px] leading-[1.1] text-[#0A1F44] tracking-tight">
        {title}
      </h2>
      <span className="mt-5 h-[2px] w-12 bg-[#D4AF37]" />
      {description && (
        <p className="mt-5 text-[15px] md:text-[16px] leading-relaxed text-[#4B5563] max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
}
